import AdList from './ad-list';

export default AdList;
